/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { hideLoader, showLoader, setTitle } from "../../reducers/loaderReducer";
import { useDispatch, useSelector } from "react-redux";
import {
  criteriosGet,
  criteriosAdd,
  criteriosUpdate,
  criteriosDelete,
} from "../../services/criterios";
import { getValues } from "../../reducers/loginReducer";
import TableComponent from "../../components/Table/criterios";
import ModalAdd from "./Modals/ModalAdd";
import { toast } from "react-hot-toast";
import ModalUpdate from "./Modals/ModalUpdate";

const columns = ["Nombre", "Valor"];
const dataGet = ["npmbre", "valor"];
export default function Index() {
  const dispatch = useDispatch();
  const { token } = useSelector(getValues);
  const [Data, setData] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [openUpdate, setopenUpdate] = React.useState(false);
  const [dataUpdate, setDataUpdate] = React.useState({});

  const openModal = () => {
    setOpen(true);
  };

  useEffect(() => {
    dispatch(setTitle("Descargando criterios"));
    dispatch(showLoader());
    getInfo();
    return () => {};
  }, []);

  const getInfo = async () => {
    const response = await criteriosGet(token);
    dispatch(hideLoader());
    dispatch(setTitle("Listado de criterios"));
    setData(response.data);
  };

  const openModalUpdateData = (data) => {
    setDataUpdate(data);
    setopenUpdate(true);
  };

  const saveInfo = (data) => {
    const save = async () => {
      const info = await criteriosAdd(data, token);
      if (info?.success === true) {
        setOpen(false);
        toast.success("criterio guardado con exito");
        getInfo();
      } else {
        toast.error("Error al guardar el criterio");
      }
    };
    save();
  };

  const updateInfo = (data) => {
    const save = async () => {
      const info = await criteriosUpdate(data, token);
      if (info?.success === true) {
        setopenUpdate(false);
        toast.success("criterio actualizado con exito");
        getInfo();
      } else {
        toast.error("Error al actualizar el criterio");
      }
    };
    save();
  };

  const deleteDato = async (id) => {
    const info = await criteriosDelete(
      {
        id,
      },
      token
    );
    if (info?.success === true) {
      toast.success("criterio eliminado con exito");
      getInfo();
    } else {
      toast.error("Error al eliminar el criterio");
    }
  };

  return (
    <div className="container mt-5">
      {open && <ModalAdd open={open} setOpen={setOpen} saveInfo={saveInfo} />}
      {openUpdate && (
        <ModalUpdate
          open={openUpdate}
          setOpen={setopenUpdate}
          saveInfo={updateInfo}
          data={dataUpdate}
        />
      )}
      <TableComponent
        title="Listado de criterios"
        data={Data ?? []}
        columns={columns}
        dataGet={dataGet}
        deleteDato={deleteDato}
        openModal={openModal}
        updateData={openModalUpdateData}
      />
    </div>
  );
}
